import { Route, Routes } from 'react-router-dom';
import TradingPartnerHome from './TradingPartnerHome.tsx';

const LimitedAccessRouter = () => (
  <Routes>
    <Route path="/" element={<TradingPartnerHome />} />
  </Routes>
);

export default LimitedAccessRouter;
